export const LOCALES = {
    ENGLISH: "en",
    CHINESE: "zh",
    MALAY: "ms",
}